import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IGetPageTypeMetadataPayload } from '../../../action/http.action';
import { DesignTypeEnum } from '../../../enum/design-type.enum';

export const getDesignObjectMetadata = (type: DesignTypeEnum, definitionId: string) => returnAction<IGetPageTypeMetadataPayload>(ActionEnum.HTTP_GET_DESIGN_OBJECT_METADATA, {
  type,
  definitionId
});
